"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = __importDefault(require("es6-promise"));
var custom_event_1 = __importDefault(require("../lib/custom-event"));
es6_promise_1.default.polyfill(); // polyfill은 항상 처음에 위치할 것 (or 다른 import되는 모듈에서 Promise not defined 오류 발생)
custom_event_1.default.polyfill(); // polyfill은 항상 처음에 위치할 것 (or 다른 import되는 모듈에서 Promise not defined 오류 발생)
require("../style.scss");
require("./product-detail.scss");
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Cafe24Client_1 = require("../lib/Cafe24Client");
var Component_1 = require("../lib/Component");
var contants_1 = require("../lib/contants");
var NsrAddonApi_1 = require("../lib/NsrAddonApi");
var util_1 = require("../lib/util");
var ProductGallery_1 = require("./ProductGallery");
var StoreSearch_1 = require("./StoreSearch");
var ProductDetail = /** @class */ (function (_super) {
    __extends(ProductDetail, _super);
    function ProductDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductDetail.prototype.onInit = function () {
        var prno = +window.iProductNo;
        if (!prno)
            return console.warn('No iProductNo found');
        var xansProductImage = this.$element.findFirst('.xans-product-image');
        if (!xansProductImage)
            return console.warn('Cannot find .xans-product-image');
        var tbodyProductOption = this.$element.findFirst('tbody.xans-product-option');
        if (!tbodyProductOption)
            return console.warn('Cannot find tbody.xans-product-option');
        var style = window.getComputedStyle(xansProductImage);
        var offsetWidth = xansProductImage.offsetWidth;
        var galleryStyle = {
            position: style.position === 'absolute' ? 'absolute' : 'relative',
            top: style.top,
            right: style.right,
            bottom: style.bottom,
            left: style.left,
            width: offsetWidth ? offsetWidth + 'px' : style.width,
            float: style.float,
            marginLeft: style.marginLeft,
            marginRight: style.marginRight,
            marginTop: style.marginTop,
            marginBottom: style.marginBottom
        };
        xansProductImage.classList.add('hidden');
        var cp$ = Cafe24Client_1.Cafe24Client.instance().getProductInfo(prno).pipe(operators_1.shareReplay(1));
        rxjs_1.combineLatest([
            cp$,
            NsrAddonApi_1.NsrAddonApi.fetchProdOptImages({ prno: prno }).pipe(operators_1.map(function (res) { return res.data; }))
        ]).subscribe({
            next: function (_a) {
                var _b, _c;
                var cp = _a[0], ap = _a[1];
                // CAFE24 상품 색상(첫번째)옵션에 존재하는 옵션값 목록만 간추린다.
                var colorTexts = lodash_1.map((_c = (_b = cp.options) === null || _b === void 0 ? void 0 : _b.options[0]) === null || _c === void 0 ? void 0 : _c.option_value, function (ov) { return ov.option_text_alias || ov.option_text; });
                ap.color_options = lodash_1.filter(ap.color_options, function (co) { return lodash_1.includes(colorTexts, co.opt_value); });
                if (ap.color_options && ap.color_options.length) {
                    if (xansProductImage) {
                        new ProductGallery_1.ProductGallery(xansProductImage, galleryStyle, cp, ap).bindTo(tbodyProductOption);
                    }
                }
                else {
                    console.warn('색상별 이미지 설정되지 않음');
                    // 주의 - remove('hidden', 'suspend-img') 형태로 사용하면 IE11에서 두번째 파라미터를 처리하지 못함
                    xansProductImage.classList.remove('hidden');
                    xansProductImage.classList.remove('suspend-img');
                }
            },
            error: function (err) {
                console.warn(err.message || err);
                // 주의 - remove('hidden', 'suspend-img') 형태로 사용하면 IE11에서 두번째 파라미터를 처리하지 못함
                xansProductImage.classList.remove('hidden');
                xansProductImage.classList.remove('suspend-img');
            },
        });
        if (lodash_1.includes(contants_1.SHOPS_WITH_STORE_SEARCH, Cafe24Client_1.Cafe24Client.instance().SHOP_NO)) {
            cp$.subscribe({
                next: function (cp) {
                    var infoArea = util_1.$helper(tbodyProductOption).parents(function (p) { return util_1.hasClass(p, 'infoArea'); });
                    if (infoArea) {
                        new StoreSearch_1.StoreSearch(infoArea, cp, { fullsize: false }).init();
                    }
                    else {
                        console.warn('Cannot find <table> which is the parent of .xans-product-option');
                    }
                },
                error: function (err) { return console.warn(err.message || err); }
            });
        }
    };
    return ProductDetail;
}(Component_1.Component));
util_1.startOnLoaded(function () {
    console.log('Initializing nsr-addon.product-detail');
    var container = document.querySelector('.xans-product-detail');
    if (container) {
        new ProductDetail(container).init();
    }
    else
        throw new Error('Not found .xans-product-detail');
});
